import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { TriangleWarning } from "components/icons/TriangleWarning";
import { ModalProps } from "types/utils/modal";

export const MovePrivateFileToPublicAlert = ({
  isOpen,
  close,
  isLoading,
  moveFileToPublic,
}: ModalProps & {
  isLoading?: boolean;
  moveFileToPublic: () => void;
}) => {
  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <Modal.Body>
          <div>
            <span className="t-text-orange t-flex t-items-center t-justify-center t-w-10 t-h-10 t-rounded-full t-shadow-[0px_0px_0px_4px_rgba(255,220,78,0.15)] t-border t-border-orange-20 t-border-solid t-bg-yellow-20">
              <TriangleWarning />
            </span>
            <p className="t-mb-2 t-text-subtext t-mt-5">
              Move file to a public location?
            </p>
            <div className="t-text-body-sm t-text-text-30">
              You are moving this file to a public location. It will become
              visible to customers. Are you sure you want to continue?
            </div>
          </div>
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Cancel</Button>
          </Modal.RawClose>
          <Button
            isLoading={isLoading}
            disabled={isLoading}
            customType="primary"
            onClick={moveFileToPublic}
          >
            Proceed
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
